import { createSlice } from '@reduxjs/toolkit';

const initialState = {  
    activeObj:{},  
};

export const objSlice = createSlice({
    name: 'obj',
    initialState,
    reducers: { 
        setActiveObj: (state, action) => {
            const { key, data } = action.payload;
            state.activeObj[key] = data;  
        },
        
        clearObj: () => {
            return { ...initialState };
        },
       
    },
});

export default objSlice.reducer;
export const { setActiveObj,clearObj } = objSlice.actions;
